<template>
  <PDF :src="$parent.parameters.source_path" />
</template>

<script>
import PDF from '@components/pdf'
export default {
  components: { PDF },
  props: [ 'src' ]
}
</script>